
import { common } from './common/it';
import { products } from './products/it';
import { pricing } from './pricing/it';
import { solutions } from './solutions/it';

export const it = {
  ...common,
  ...products,
  ...pricing,
  ...solutions,
};
